import { AddNewProduct } from '@/models/add-new-product/add-new-product';
import { CategoryDetails } from '@/models/category-details/category-details';
import { ImageDetails } from '@/models/image-details/image-details';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-add-new-product',
  templateUrl: './add-new-product.component.html',
  styleUrl: './add-new-product.component.scss'
})
export class AddNewProductComponent implements OnInit {
  dropdownList = [];
  sizeList: any[] = [];
  selectedItemsDepotNumber = [];
  dropdownSettings = {};
  forms: any[] = [];
  mainImage: string | null = null;
  mainImageShow: boolean = false;
  imageList: ImageDetails[] = [];
  mainImageId: number = 0;
  description: string = "";
  categoryDetails: CategoryDetails[] = [];
  currentCategoryId: any;
  productId: number = 0;
  destroy$: Subject<boolean> = new Subject<boolean>();
  CurrentProductDetails: AddNewProduct;
  endPoint: string = "";
  isUpdate: boolean = false;
  variantCount: number = 1;
  sareeVariantCount: number = 1;
  showVariantPopup = false;
  filteredSubCategories: any[] = [];
  editorModules = {
    toolbar: [
      [{ 'header': ['4', '5', '6'] }, { 'font': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],
      ['clean']
    ]
  };
  bulkCharacterName: string = '';
  bulkStartNumber: number | null = null;
  bulkEndNumber: number | null = null;
  bulkSrp: number | null = null;

  bulkSubmitted: boolean = false;
  bulkRangeErrorMessage: string = '';
  bulkVariantTotal: number = 0;

  constructor(private toastr: ToastrService, private appService: AppService, private spinner: NgxSpinnerService,
    private configService: ConfigService, private router: Router, private fb: FormBuilder
  ) {
  }

  newProduct = this.fb.group({
    productId: [0],
    productName: ['', Validators.required],
    productCode: [''],
    description: ['', Validators.required],
    price: [0],
    shopId: [1],
    availability: ['Yes'],
    totalQuantity: [0],
    categoryId: [0, this.zeroNotAllowedValidator],
    subCategoryId: [0],
    createdAt: [0],
    createdBy: [''],
    updatedAt: [0],
    youtubeLink: ['', this.youtubeValidator()],
    discounts: this.fb.array([]),
    variants: this.fb.array([], Validators.required),
    isLive: false,
    hsnCode: ['', Validators.required],
  });


  youtubeValidator() {
    return (control: any) => {
      const value = control.value?.trim();
      if (!value) return null; // empty allowed

      const ytRegex =
        /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/)[\w-]{11}(\?.*)?$/;

      return ytRegex.test(value) ? null : { invalidYoutube: true };
    };
  }


  public newProductError = {
    productName: '',
    description: '',
    hsnCode: '',
  }

  ngOnInit() {
    this.isUpdate = false;
    this.sizeList = [
      { id: 1, label: 'ALL_SIZE' },

      { id: 2, label: 'XXS(32)' },
      { id: 3, label: '33' },

      { id: 4, label: 'XS(34)' },
      { id: 5, label: '35' },

      { id: 6, label: 'S(36)' },
      { id: 7, label: '37' },

      { id: 8, label: 'M(38)' },
      { id: 9, label: '39' },

      { id: 10, label: 'L(40)' },
      { id: 11, label: '41' },

      { id: 12, label: 'XL(42)' },
      { id: 13, label: '43' },

      { id: 14, label: 'XXL(44)' },
      { id: 15, label: '45' },

      { id: 16, label: '3XL(46)' },
      { id: 17, label: '47' },

      { id: 18, label: '4XL(48)' },
      { id: 19, label: '49' },

      { id: 20, label: '5XL(50)' },
      { id: 21, label: '51' },

      { id: 22, label: '6XL(52)' }
    ];
    this.getCategoryDetails();
    this.productId = Number(localStorage.getItem('productId'));
    if (this.productId) {
      this.isUpdate = true;
      this.getProductById();
    } else {
      this.addVariant();
    }
    this.endPoint = this.configService.getConfig().END_POINT;
  }

  get variants(): FormArray {
    return this.newProduct.get('variants') as FormArray;
  }

  zeroNotAllowedValidator(control: any) {

    if (control.value === 0 || control.value === '0' || control.value === null || control.value === '') {
      return { required: true };   // treat 0 as invalid
    }

    return null;
  }


  onAddVariantClick() {
    this.addVariant(); // normal category
  }

 bulkVariantClick(): void {

  this.bulkCharacterName = '';
  this.bulkStartNumber = null;
  this.bulkEndNumber = null;
  this.bulkSrp = null;

  this.bulkSubmitted = false;
  this.bulkRangeErrorMessage = '';
  this.bulkVariantTotal = 0;

  this.showVariantPopup = true;
}

validateBulkRange(): void {

  this.bulkRangeErrorMessage = '';
  this.bulkVariantTotal = 0;

  if (
    this.bulkStartNumber === null ||
    this.bulkEndNumber === null ||
    this.bulkStartNumber === undefined ||
    this.bulkEndNumber === undefined
  ) {
    return;
  }

  const start = Number(this.bulkStartNumber);
  const end = Number(this.bulkEndNumber);

  // Starting number validation
  if (start <= 0) {
    this.bulkRangeErrorMessage =
      'Starting Number must be greater than 0.';
    return;
  }

  // Ending number validation
  if (end <= 0) {
    this.bulkRangeErrorMessage =
      'Ending Number must be greater than 0.';
    return;
  }

  // Start > End
  if (start > end) {
    this.bulkRangeErrorMessage =
      'Starting Number cannot be greater than Ending Number.';
    return;
  }

  // Maximum 100 variants
  const total = (end - start) + 1;

  if (total > 100) {
    this.bulkRangeErrorMessage =
      'Maximum 100 variants can be generated at one time.';
    return;
  }

  this.bulkVariantTotal = total;
}

  // Add New Variant
  addVariant() {
    this.variants.push(
      this.fb.group({
        productVariantId: [0],
        productId: [this.productId || 0],
        color: [''],
        productName: [''],
        size: ['', Validators.required],
        varientQuantity: [0, [Validators.required, Validators.min(1)]],
        varientAdditionalPrice: [0],
        createdAt: [0],
        updatedAt: [0],
        productMrp: [0, Validators.required],
        productSrp: [0, Validators.required],
        barcodeNumber: ['', Validators.required],
        productColorId: [0],
        reservedQuantity: [0],
        availableStock: [0],
        isAvailable: [true],
        images: this.fb.array([], Validators.required)
      })
    );
  }



  getVariantGroup(index: number): FormGroup {
    return this.variants.at(index) as FormGroup;
  }

  getImagesArray(variantIndex: number): FormArray {
    return this.getVariantGroup(variantIndex).get('images') as FormArray;
  }

  removeVariant(index: number) {
    this.variants.removeAt(index);
  }

  createImage(img: any) {
    return this.fb.group({
      imageDetailsId: [img.imageDetailsId || 0],
      imageDescription: [img.imageDescription || ''],
      imageExtension: [img.imageExtension || 'JPG'],
      imageType: [img.imageType || 'JPG'],
      imagePath: [img.imagePath || ''],
      imageFileName: [img.imageFileName || ''],
      referenceId: [img.referenceId || 0],
      createdAt: [0],
      imageData: [img.imageData || ''],
      isActive: [img.isActive ?? true],
      isPrimary: [img.isPrimary ?? false]
    });
  }


  get discounts(): FormArray {
    return this.newProduct.get('discounts') as FormArray;
  }

  addDiscount() {
    this.discounts.push(
      this.fb.group({
        discountId: [0],
        productVariantId: [0],
        productId: [this.productId || 0],
        discountQuantity: [null, Validators.required],
        discountAmount: [null, Validators.required],
        createdAt: [0]
      })
    );
  }

  removeDiscount(index: number) {

    const discountGroup = this.discounts.at(index);
    const discountId = discountGroup.get('discountId')?.value;

    // If discount already saved in DB → call API
    if (discountId) {
      this.appService.deleteDiscountById(discountId).subscribe({
        next: () => {
          this.discounts.removeAt(index);
        },
        error: (err) => {
          this.toastr.error('Delete failed', err);
        }
      });
    }
    // If discount not saved yet → remove locally only
    else {
      this.discounts.removeAt(index);
    }

  }

  confirmBulkVariant(): void {

  this.bulkSubmitted = true;

  const characterName =
    (this.bulkCharacterName || '').trim().toUpperCase();

  const start = Number(this.bulkStartNumber);
  const end = Number(this.bulkEndNumber);
  const srp = Number(this.bulkSrp);

  // =====================================
  // CHARACTER NAME VALIDATION
  // =====================================

  if (!characterName) {
    this.toastr.error('Character Name is required.');
    return;
  }

  if (!/^[A-Z0-9]+$/i.test(characterName)) {
    this.toastr.error(
      'Character Name can contain only letters and numbers.'
    );
    return;
  }

  // =====================================
  // START NUMBER VALIDATION
  // =====================================

  if (!start || start <= 0) {
    this.toastr.error(
      'Starting Number must be greater than 0.'
    );
    return;
  }

  // =====================================
  // END NUMBER VALIDATION
  // =====================================

  if (!end || end <= 0) {
    this.toastr.error(
      'Ending Number must be greater than 0.'
    );
    return;
  }

  // =====================================
  // START > END
  // =====================================

  if (start > end) {

    this.bulkRangeErrorMessage =
      'Starting Number cannot be greater than Ending Number.';

    this.toastr.error(
      'Starting Number cannot be greater than Ending Number.'
    );

    return;
  }

  // =====================================
  // MAXIMUM VARIANTS
  // =====================================

  const total = (end - start) + 1;

  if (total > 100) {

    this.bulkRangeErrorMessage =
      'Maximum 100 variants can be generated at one time.';

    this.toastr.error(
      'Maximum 100 variants can be generated at one time.'
    );

    return;
  }

  // =====================================
  // SRP VALIDATION
  // =====================================

  if (!srp || srp <= 0) {

    this.toastr.error(
      'SRP must be greater than 0.'
    );

    return;
  }

  // =====================================
  // EXISTING BARCODE CHECK
  // =====================================

  const existingBarcodes = new Set<string>();

  this.variants.controls.forEach(control => {

    const barcode =
      String(
        control.get('barcodeNumber')?.value || ''
      )
        .trim()
        .toUpperCase();

    if (barcode) {
      existingBarcodes.add(barcode);
    }

  });


  // =====================================
  // GENERATE
  // =====================================

  let addedCount = 0;
  const duplicateBarcodes: string[] = [];


  for (
    let number = start;
    number <= end;
    number++
  ) {

    const barcode =
      `${characterName}${number}`;


    // Duplicate barcode
    if (existingBarcodes.has(barcode)) {

      duplicateBarcodes.push(barcode);

      continue;
    }


    // =====================================
    // FIRST VARIANT
    // USE EXISTING EMPTY VARIANT
    // =====================================

    if (
      addedCount === 0 &&
      this.variants.length === 1 &&
      this.isVariantEmpty(this.variants.at(0))
    ) {

      const firstVariant =
        this.variants.at(0) as FormGroup;

      firstVariant.patchValue({

        productVariantId: 0,

        productId: this.productId || 0,

        barcodeNumber: barcode,

        size: 'ALL_SIZE',

        varientQuantity: 1,

        productMrp: srp,

        productSrp: srp,

        isAvailable: true

      });

      addedCount++;

      existingBarcodes.add(barcode);

      continue;
    }


    // =====================================
    // ADD NEW VARIANT
    // =====================================

    const variantGroup =
      this.createVariantGroup();


    variantGroup.patchValue({

      productVariantId: 0,

      productId: this.productId || 0,

      barcodeNumber: barcode,

      size: 'ALL_SIZE',

      varientQuantity: 1,

      productMrp: srp,

      productSrp: srp,

      isAvailable: true

    });


    this.variants.push(variantGroup);

    existingBarcodes.add(barcode);

    addedCount++;

  }


  // =====================================
  // RESULT
  // =====================================

  if (addedCount === 0) {

    this.toastr.warning(
      'No new variants were added.'
    );

    return;
  }


  if (duplicateBarcodes.length > 0) {

    this.toastr.warning(
      `${duplicateBarcodes.length} duplicate barcode(s) skipped.`
    );

  }


  this.toastr.success(
    `${addedCount} variant(s) generated successfully.`
  );


  // =====================================
  // CLOSE POPUP
  // =====================================

  this.showVariantPopup = false;

  this.resetBulkVariant();

}

isVariantEmpty(control: AbstractControl): boolean {

  const barcode =
    control.get('barcodeNumber')?.value;

  const size =
    control.get('size')?.value;

  const quantity =
    control.get('varientQuantity')?.value;

  const mrp =
    control.get('productMrp')?.value;

  const srp =
    control.get('productSrp')?.value;

  return (
    !barcode &&
    (!size || size === 'ALL_SIZE') &&
    (!quantity || Number(quantity) === 0) &&
    (!mrp || Number(mrp) === 0) &&
    (!srp || Number(srp) === 0)
  );
}

resetBulkVariant(): void {

  this.bulkCharacterName = '';

  this.bulkStartNumber = null;

  this.bulkEndNumber = null;

  this.bulkSrp = null;

  this.bulkSubmitted = false;

  this.bulkRangeErrorMessage = '';

  this.bulkVariantTotal = 0;
}

cancelVariantPopup(): void {

  this.showVariantPopup = false;

  this.resetBulkVariant();
}

  createVariantGroup(): FormGroup {
    return this.fb.group({
      productVariantId: [0],
      productId: [this.productId || 0],
      size: ['ALL_SIZE', Validators.required],
      varientQuantity: [1, [Validators.required, Validators.min(1)]],
      productMrp: [0, Validators.required],
      productSrp: [0, Validators.required],
      barcodeNumber: ['', Validators.required],
      isAvailable: [true],
      images: this.fb.array([], Validators.required)
    });
  }

  isBulkInsertCategory(): boolean {

    const rawValue = this.newProduct.get('categoryId')?.value;

    // Convert to number safely
    const selectedCategoryId = Number(rawValue);

    // If not selected OR default 0 → return false
    if (!selectedCategoryId || selectedCategoryId === 0) {
      return false;
    }

    // Find category using numeric comparison
    const selectedCategory = this.categoryDetails.find(
      c => Number(c.categoryId) === selectedCategoryId
    );

    // Return boolean safely
    return !!selectedCategory?.isBulkInsert;
  }
  //Get all category details
  getCategoryDetails() {
    this.spinner.show();
    this.appService.getCategoryDetailsByActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.categoryDetails = data;
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.message || "Something Went wrong, please try again...")
      })
  }

  onSelectCategory(event: any): void {

    const categoryId = Number(event.target.value);
    this.currentCategoryId = categoryId;

    // Find selected category
    const selectedCategory = this.categoryDetails.find(
      c => c.categoryId === categoryId
    );

    // Load its subcategories
    this.filteredSubCategories = selectedCategory?.subCategories || [];

    // Reset previously selected subcategory
    this.newProduct.patchValue({ subCategoryId: 0 });
  }


  onSelectSubCategory(event: any): void {

    const subCategoryId = Number(event.target.value);
    this.newProduct.patchValue({
      subCategoryId: subCategoryId
    });
  }



  onSubmit() {
    this.formValidation();
  }

  formValidation() {
    let hasError = false;

    // reset custom error object
    this.newProductError = {
      productName: '',
      description: '',
      hsnCode: '',
    };

    /* ================= PRODUCT LEVEL ================= */

    if (this.newProduct.get('productName')?.invalid) {
      this.newProductError.productName = 'Product Name is required';
      hasError = true;
    }

    if (this.newProduct.get('hsnCode')?.invalid) {
      this.newProductError.hsnCode = 'Hsn Code is required';
      hasError = true;
    }

    // Mark product controls touched
    this.newProduct.markAllAsTouched();

    /* ================= COD VALIDATION ================= */

    const codOption = this.newProduct.get('cashOnDeliveryOption')?.value;
    const codAmount = this.newProduct.get('cashOnDeliveryAmount');

    if (codOption === 'YES' && (!codAmount?.value || codAmount.value <= 0)) {
      this.toastr.error('COD amount is required');
      codAmount?.markAsTouched();
      hasError = true;
    }

    /* ================= VARIANTS ================= */

    const variants = this.newProduct.get('variants') as FormArray;

    if (!variants || variants.length === 0) {
      this.toastr.error('At least one variant is required');
      return; // hard stop
    }

    variants.controls.forEach((variant, vi) => {
      const fg = variant as FormGroup;

      // Mark variant controls touched
      fg.markAllAsTouched();

      // Required variant fields
      const requiredFields = [
        { key: 'barcodeNumber', label: 'Barcode Number' },
        { key: 'size', label: 'Size' },
        { key: 'varientQuantity', label: 'Quantity' },
        { key: 'productSrp', label: 'SRP' },
      ];

      for (const field of requiredFields) {
        const ctrl = fg.get(field.key);

        if (field.key === 'barcodeNumber') {
          if (!ctrl?.value || ctrl.value.toString().trim() === '') {
            this.toastr.error(`Variant ${vi + 1}: ${field.label} is required`);
            hasError = true;
            break;
          }
        } else {
          if (ctrl?.value === null || ctrl?.value === undefined || ctrl.value < 0) {
            this.toastr.error(`Variant ${vi + 1}: ${field.label} cannot be negative`);
            hasError = true;
            break;
          }
        }
      }

      /* ---------- IMAGE VALIDATION (STRICT) ---------- */
      const images = fg.get('images') as FormArray;

      // CASE 1: No images → ALLOWED during save
      if (!images || images.length === 0) {
        return; // skip validation
      }

      // CASE 2: Images exist → enforce primary rules
      const primaryImages = images.controls.filter(
        img => img.get('isPrimary')?.value === true
      );

      if (primaryImages.length === 0) {
        this.toastr.error(`Variant ${vi + 1}: Select one primary image`);
        hasError = true;
      }

      if (primaryImages.length > 1) {
        this.toastr.error(`Variant ${vi + 1}: Only one primary image allowed`);
        hasError = true;
      }
    });

    /* ================= FINAL SUBMIT ================= */

    if (hasError) {
      return;
    }

    if (this.isUpdate) {
      this.updateProductDetails();
    } else {
      this.saveProductDetails();
    }
  }


  isInvalidError(controlName: string): boolean {
    const ctrl = this.newProduct.get(controlName);
    return !!(ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched));
  }

  isInvalid(control: AbstractControl | null, field?: string): boolean {
    if (!control) return false;
    const target = field ? control.get(field) : control;
    return !!(target && target.invalid && (target.touched || target.dirty));
  }



  getProductById() {
    this.spinner.show();
    this.appService.getProductIdByDetails(this.productId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.CurrentProductDetails = data;
        this.currentCategoryId = data.categoryId;
        this.setValueFunction();
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.message || "Something Went wrong, please try again...")
      })
  }

  setValueFunction() {
    const product = this.CurrentProductDetails;

    // ---------- PRODUCT ----------
    this.newProduct.patchValue({
      productId: product.productId,
      productName: product.productName,
      productCode: product.productCode,
      description: product.description,
      availability: product.availability,
      categoryId: product.categoryId,
      youtubeLink: product.youtubeLink,
      createdAt: product.createdAt,
      createdBy: product.createdBy,
      updatedAt: product.updatedAt,
      isLive: product.isLive,
      hsnCode: product.hsnCode,
    });

    this.loadSubCategories(product);

    /* ================= DISCOUNTS ================= */
    const discountArray = this.discounts;
    discountArray.clear();

    (product.discounts || []).forEach(d => {
      discountArray.push(
        this.fb.group({
          discountId: [d.discountId],
          productVariantId: [d.productVariantId],
          productId: [product.productId],
          discountQuantity: [d.discountQuantity],
          discountAmount: [d.discountAmount],
          createdAt: [d.createdAt]
        })
      );
    });

    // ---------- VARIANTS ----------
    const variantsArray = this.variants;
    variantsArray.clear();

    (product.variants || []).forEach(v => {
      // Create images FormArray
      const imagesArray = this.fb.array(
        (v.images || []).map(img =>
          this.fb.group({
            imageDetailsId: [img.imageDetailsId],
            imageDescription: [img.imageDescription],
            imageExtension: [img.imageExtension],
            imageType: [img.imageType],
            imagePath: [img.imagePath],
            imageFileName: [img.imageFileName],
            imageName: [img.imageFileName.split('.')[0]],
            referenceId: [img.referenceId],
            createdAt: [img.createdAt],
            imageData: [''], // backend image not re-sent
            temporaryImagePath: [''], // for preview if needed
            isActive: [img.isActive ?? true],
            isPrimary: [img.isPrimary ?? false] // ✅ mark primary from backend
          })
        )
      );

      // Push variant
      variantsArray.push(
        this.fb.group({
          productVariantId: [v.productVariantId],
          productId: [product.productId],
          size: [v.size, Validators.required],
          varientQuantity: [v.varientQuantity, Validators.required],
          productMrp: [v.productMrp, Validators.required],
          productSrp: [v.productSrp, Validators.required],
          barcodeNumber: [v.barcodeNumber, Validators.required],
          isAvailable: [v.isAvailable ?? true],
          hsnCode: [v.hsnCode],
          images: imagesArray
        })
      );

      // Ensure **one primary image per variant** if none is marked
      let primaryCount = imagesArray.controls.filter(
        c => c.get('isPrimary')?.value
      ).length;

      // No primary → assign first
      if (primaryCount === 0 && imagesArray.length > 0) {
        imagesArray.at(0).get('isPrimary')?.setValue(true);
      }

      // Multiple primary → fix
      if (primaryCount > 1) {
        let found = false;
        imagesArray.controls.forEach(ctrl => {
          if (ctrl.get('isPrimary')?.value && !found) {
            found = true;
          } else {
            ctrl.get('isPrimary')?.setValue(false);
          }
        });
      }
    });
  }


  loadSubCategories(product: any): void {

    const selectedCategory = this.categoryDetails.find(
      c => c.categoryId === Number(product.categoryId)
    );

    this.filteredSubCategories = selectedCategory?.subCategories || [];
    this.newProduct.patchValue({
      subCategoryId: product.subCategoryId
    });
  }


  onContentChanged(event: any): void {
    this.description = event.html;
  }

  // ------------------ IMAGE UPLOAD --------------------
  async onFileSelected(event: Event, variantIndex: number) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files.length) return;

    const imagesCtrl = this.getImagesArray(variantIndex);

    for (let idx = 0; idx < input.files.length; idx++) {
      const file = input.files[idx];
      const compressedBase64 = await this.compressImage(file, 800, 800, 0.8);

      const hasPrimary = imagesCtrl.controls.some(
        c => c.get('isPrimary')?.value
      );

      imagesCtrl.push(this.fb.group({
        imageDetailsId: [0],
        imageDescription: [''],
        imageExtension: file.type.includes('png') ? 'PNG' : 'JPG',
        imageType: file.type.includes('png') ? 'PNG' : 'JPG',
        imagePath: [''],
        imageName: file.name.split('.')[0],
        imageFileName: file.name,
        referenceId: [0],
        createdAt: [0],
        imageData: [compressedBase64.split(',')[1]],
        temporaryImagePath: [compressedBase64],   // preview
        isActive: [true],
        isPrimary: [!hasPrimary && idx === 0]  // primary fixed
      }));
    }

    input.value = '';
  }

  compressImage(
    file: File,
    maxWidth: number,
    maxHeight: number,
    quality = 0.8
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }

          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx!.drawImage(img, 0, 0, width, height);

          const base64 = canvas.toDataURL('image/jpeg', quality);
          resolve(base64); // 👈 MUST RESOLVE
        };
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  getImagePreview(imgCtrl: AbstractControl): string {
    // NEW image preview
    const temp = imgCtrl.get('temporaryImagePath')?.value;
    if (temp) return temp;

    // EXISTING image from server
    const id = imgCtrl.get('imageDetailsId')?.value;
    if (id) {
      return `${this.endPoint}/api/product/image-details/get/${id}`;
    }

    return 'assets/no-image.png'; // fallback
  }



  resizeImage(image: HTMLImageElement, width: number, height: number): Promise<string> {
    return new Promise(resolve => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d')!;
      ctx.drawImage(image, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.9));
    });
  }

  setPrimaryImage(variantIndex: number, imageIndex: number) {
    const imagesArray = this.getImagesArray(variantIndex);

    imagesArray.controls.forEach((imgCtrl, idx) => {
      imgCtrl.get('isPrimary')?.setValue(idx === imageIndex);
    });

    imagesArray.markAsDirty();
    imagesArray.markAsTouched();
  }

  hasImageError(variantGroup: FormGroup): boolean {
    const images = variantGroup.get('images') as FormArray;

    if (!images || images.length === 0) return true;

    const hasPrimary = images.value.some(
      (img: any) => img.isPrimary === true
    );

    return !hasPrimary;
  }



  removeImage(variantIndex: number, imageIndex: number) {
    const imagesArray = this.getImagesArray(variantIndex);

    if (!imagesArray) return;

    // Prevent removing last image
    if (imagesArray.length <= 1) {
      this.toastr.error('At least one image is required.');
      return;
    }

    const imgGroup = imagesArray.at(imageIndex) as FormGroup;
    const imageDetailsId = imgGroup.get('imageDetailsId')?.value;
    const wasPrimary = imgGroup.get('isPrimary')?.value;

    const handleAfterRemove = () => {
      imagesArray.removeAt(imageIndex);

      // FIX: If removed image was primary → assign new one
      if (wasPrimary && imagesArray.length > 0) {
        imagesArray.controls.forEach((ctrl, idx) => {
          ctrl.get('isPrimary')?.setValue(idx === 0);
        });
      }

      // SAFETY: Ensure ONLY ONE primary
      let primaryFound = false;
      imagesArray.controls.forEach(ctrl => {
        if (ctrl.get('isPrimary')?.value && !primaryFound) {
          primaryFound = true;
        } else {
          ctrl.get('isPrimary')?.setValue(false);
        }
      });

      // FINAL FALLBACK (no primary at all)
      if (!primaryFound && imagesArray.length > 0) {
        imagesArray.at(0).get('isPrimary')?.setValue(true);
      }

      imagesArray.markAsDirty();
      imagesArray.markAsTouched();

      this.toastr.success('Image removed successfully.');
    };

    // 🔹 SERVER IMAGE DELETE
    if (imageDetailsId && imageDetailsId > 0) {
      this.spinner.show();

      this.appService
        .deleteImageByAssetId(imageDetailsId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.spinner.hide();
            handleAfterRemove(); // common logic
          },
          error: (err) => {
            this.spinner.hide();
            this.toastr.error(err?.error?.message || 'Cannot delete image');
          }
        });
    }
    // 🔹 LOCAL IMAGE DELETE
    else {
      handleAfterRemove(); // same logic reuse
    }
  }




  private afterImageRemove(
    images: ImageDetails[],
    removedIndex: number,
    imagesControl: AbstractControl
  ) {
    const wasPrimary = images[removedIndex]?.isPrimary;

    images.splice(removedIndex, 1);

    // If primary image removed → assign first image as primary
    if (wasPrimary && images.length > 0) {
      images.forEach(img => img.isPrimary = false);
      images[0].isPrimary = true;
    }

    imagesControl.setValue(images);
    imagesControl.markAsDirty();
    imagesControl.updateValueAndValidity();
  }



  // Helper: update primary index
  handlePrimaryAfterRemove(color: AbstractControl, images: ImageDetails[], removedIndex: number) {
    let newPrimaryIndex = images.findIndex(img => img.isPrimary);
    if (newPrimaryIndex === -1 && images.length > 0) {
      images[0].isPrimary = true;
      newPrimaryIndex = 0;
    }
    color.patchValue({
      images: images,
      primaryImageIndex: images.length ? newPrimaryIndex : -1
    });
  }


  saveProductDetails() {
    this.spinner.show();
    this.newProduct.controls['categoryId'].setValue(this.currentCategoryId);
    const payload = this.prepareFullPayload();
    this.appService.saveNewProduct([payload])
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();;
        this.saveAlert();
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error.message || "Something went wrong, please try again");
      })
  }

  updateProductDetails() {
    this.spinner.show();
    this.newProduct.controls['categoryId'].setValue(this.currentCategoryId);
    const payload = this.prepareFullPayload();
    this.appService.updateProductDetails(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const imageList: ImageDetails[] = [];
        this.variants.controls.forEach((variantCtrl: any) => {
          const images: ImageDetails[] = variantCtrl.get('images')?.value || [];
          imageList.push(...images);
        });
        this.spinner.hide();
        this.toastr.success("Product updated successfully.");
        this.router.navigate(['/main/product-view']);
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error.message || "Something went wrong, please try again");
      })
  }

  updateAssetImage(productId: number) {
    const newImages: any[] = [];

    this.variants.controls.forEach((variantCtrl: any) => {
      const variantId = variantCtrl.get('productVariantId')?.value;
      const images = variantCtrl.get('images')?.value || [];

      images.forEach((img: any) => {
        if (!img.imageDetailsId || img.imageDetailsId === 0) {
          newImages.push({
            imageDetailsId: img.imageDetailsId,
            referenceId: 0,
            imageDescription: img.imageDescription,
            imageExtension: img.imageExtension,
            imageType: img.imageType,
            imagePath: img.imagePath,
            createdAt: 0,
            imageFileName: img.imageFileName,
            imageData: img.imageData,
            isActive: img.isActive,
            isPrimary: img.isPrimary,

          });
        }
      });
    });

    if (!newImages.length) {
      this.spinner.hide();
      this.toastr.success("Product updated successfully.");
      this.router.navigate(['/main/product-view']);
      return;
    }

    this.appService.updateProductImage(productId, newImages)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success("Product details and images updated successfully.");
          this.router.navigate(['/main/product-view']);
        },
        error: (err) => {
          this.spinner.hide();
          this.toastr.error(err.error.message || "Something went wrong while updating images");
        }
      });
  }

  prepareFullPayload(): any {
    const product = this.newProduct.value;
    console.log(product)
    return {
      productId: product.productId,
      productName: product.productName,
      productCode: product.productCode,
      description: product.description,
      price: product.price,
      shopId: product.shopId,
      availability: product.availability,
      totalQuantity: product.totalQuantity,
      categoryId: Number(product.categoryId),
      subCategoryId: product.subCategoryId ? Number(product.subCategoryId) : null,
      createdAt: product.createdAt,
      createdBy: product.createdBy,
      updatedAt: product.updatedAt,
      youtubeLink: product.youtubeLink,
      isLive: product.isLive,
      hsnCode: product.hsnCode,

      discounts: (product.discounts || []).map((d: any) => ({
        discountId: d.discountId,
        productVariantId: d.productVariantId,
        productId: product.productId,
        discountQuantity: d.discountQuantity,
        discountAmount: d.discountAmount,
        createdAt: d.createdAt
      })),

      variants: (product.variants || []).map((v: any) => ({
        productVariantId: v.productVariantId,
        productId: product.productId,
        color: v.color,
        productName: product.productName,
        size: (typeof v.size === 'object' ? v.size.label : v.size)?.replace(/"/g, ''),
        varientQuantity: v.varientQuantity,
        varientAdditionalPrice: v.varientAdditionalPrice,
        createdAt: v.createdAt,
        updatedAt: v.updatedAt,
        productMrp: v.productMrp,
        productSrp: v.productSrp,
        barcodeNumber: v.barcodeNumber,
        productColorId: v.productColorId,
        reservedQuantity: v.reservedQuantity,
        availableStock: v.availableStock,
        isAvailable: v.isAvailable,
        hsnCode: v.hsnCode,

        images: (v.images || []).map((img: any) => ({
          imageDetailsId: img.imageDetailsId,
          imageDescription: img.imageDescription,
          imageExtension: img.imageExtension,
          imageType: img.imageType,
          imagePath: img.imagePath,
          imageFileName: img.imageFileName,
          referenceId: img.referenceId,
          createdAt: img.createdAt,
          imageData: img.imageData,
          isActive: img.isActive,
          isPrimary: img.isPrimary
        }))
      }))
    };
  }

  OnlyNumbers($event: KeyboardEvent) {

    let regex: RegExp = new RegExp(/^[0-9.]$/g);
    let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];

    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    }

    if (regex.test($event.key)) {
      return true;
    } else {
      $event.preventDefault();
      return false;
    }
  }

  saveAlert() {
    Swal.fire({
      title: "Product saved successfully",
      icon: "success",
      draggable: true
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }

  deleteVariant(variantIndex: number) {
    if (this.variants.length === 1) {
      this.toastr.error('At least one variant is required.');
      return;
    }
    const variants = this.variants; // FormArray
    const variantGroup = variants.at(variantIndex);

    if (!variantGroup) return;

    const variantId = variantGroup.get('productVariantId')?.value;

    // If it's the last variant on server, prevent deletion
    const serverVariantsCount = variants.controls.filter(v => (v.get('productVariantId')?.value || 0) > 0).length;
    if (serverVariantsCount <= 1 && variantId > 0) {
      this.toastr.error('Cannot delete the last variant from.');
      return;
    }

    // Ask confirmation before deletion
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this variant?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // CASE 1: Variant exists in DB
        if (variantId && variantId > 0) {
          this.spinner.show();

          this.appService.deleteProductVariantDetails(variantId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                variants.removeAt(variantIndex);
                this.spinner.hide();
                this.toastr.success('Variant deleted successfully');
              },
              error: (err) => {
                this.spinner.hide();
                this.toastr.error(err?.error?.message || 'Delete failed');
              }
            });
        }
        // CASE 2: Variant not saved yet (local only)
        else {
          variants.removeAt(variantIndex);
        }
      } else {
        return
      }
    });

  }


  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    localStorage.removeItem("productId");
  }

}
